"use client";

import React, { useState } from "react";
import { RxHamburgerMenu, RxCross1 } from "react-icons/rx";

export function Navbar3() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    // Změna: přidáno 'fixed top-0 left-0' pro fixaci na vrchu
    <nav className="fixed top-0 left-0 z-50 flex w-full items-center justify-between bg-wood-cream px-[5%] py-3 text-black md:min-h-18 shadow-sm">
      
      {/* LEVÁ ČÁST: Menu (Desktop) */}
      <div className="hidden flex-1 items-center gap-8 font-sans text-[15px] font-medium lg:flex">
        <a href="/" className="hover:opacity-60 transition-opacity uppercase tracking-wide">Tesařství</a>
        <a href="/gallery" className="hover:opacity-60 transition-opacity uppercase tracking-wide">Galerie</a>
        <a href="/contact" className="hover:opacity-60 transition-opacity uppercase tracking-wide">Kontakt</a>
      </div>

      {/* STŘEDNÍ ČÁST: Logo */}
      <div className="flex flex-1 justify-center">
        <a href="/" className="flex items-center">
          <img 
            src="/img/logo sindelar.png" 
            alt="Tesařství Šindelář" 
            className="w-[180px] h-[32px] object-contain" 
          />
        </a>
      </div>

      {/* PRAVÁ ČÁST: Telefon / Hamburger */}
      <div className="flex flex-1 justify-end items-center">
        <a 
          href="tel:+420723856780"
          className="hidden rounded-full bg-black px-5 py-2.5 font-sans font-bold text-[13px] text-white hover:bg-opacity-80 transition-all lg:flex"
        >
          VOLAT
        </a>

        <button 
          className="p-2 lg:hidden" 
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <RxCross1 size={24} /> : <RxHamburgerMenu size={24} />}
        </button>
      </div>

      {/* MOBILNÍ MENU */}
      {isMobileMenuOpen && (
        <div className="absolute left-0 top-full w-full bg-wood-cream border-t border-black/5 flex flex-col items-center gap-6 py-8 font-sans font-bold text-lg lg:hidden shadow-xl">
          <a href="/" onClick={() => setIsMobileMenuOpen(false)}>Tesařství</a>
          <a href="/gallery" onClick={() => setIsMobileMenuOpen(false)}>Galerie</a>
          <a href="/contact" onClick={() => setIsMobileMenuOpen(false)}>Kontakt</a>
          <a href="tel:+420723856780" className="mt-4 rounded-full bg-black px-6 py-3 text-white text-sm">
            Zavolat: 723 856 780
          </a>
        </div>
      )}
    </nav>
  );
}